import * as React from 'react';

import { TertiaryButton } from '@longline/aqua-ui/controls/TertiaryButton';
import { InfoBox } from '@longline/aqua-ui/containers/InfoBox';

import { ISpecies } from '../../api/models/ISpecies';

interface IProps {
  value?: ISpecies;
  onView: () => void;
}

const SpeciesInfoBox = (props: IProps) => {
  // Optional because <ListView aux> injects the active item; render nothing
  // if no item is selected.
  if (!props.value) return null;
  const species = props.value;

  const footer = <>
    <TertiaryButton disabled={!species.hydrated} onClick={props.onView}>DETAILS</TertiaryButton>
  </>

  return (
    <InfoBox
      header={species.name}
      footer={footer}
      padded
    >
      <InfoBox.Row ghost={!species.hydrated} name="Name" value={species.name}/>
      <InfoBox.Row ghost={!species.hydrated} name="Genus" value={species.genus}/>
      <InfoBox.Row ghost={!species.hydrated} name="Species" value={species.species}/>
    </InfoBox>
  )
}

export { SpeciesInfoBox }
